import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {IWarehouseProductMovement} from "../../../../../../../utils/interfaces/my_warehouse/IWarehouseProductMovement";


const useApiGetManualWarehouseProductMovement = (warehouse_id: number, product_id: number, pk: number | undefined): UseQueryResult<IWarehouseProductMovement, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(warehouse_id: number): Promise<IWarehouseProductMovement> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/my_warehouse/${warehouse_id}/products/${product_id}/movements/manual_movement/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetManualWarehouseProductMovement", warehouse_id, product_id, pk],
        queryFn: () => doGet(warehouse_id),
        enabled: !!pk,
    })
};

export default useApiGetManualWarehouseProductMovement